import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    key: _ctx.key,
    class: "AppPager-dots",
    type: "button"
  }, [
    _createElementVNode("span", {
      innerHTML: _ctx.pagerItem.html
    }, null, 8, _hoisted_1)
  ]))
}